/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * show-service.ts  2026-08-26T09:15:21+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type {
  MiniShowQuery,
  TopQuery,
  MoreVideo,
  MiniShow,
  RecShowRes,
  FeedPref,
  RecShowReq,
  FeedReq,
  FeedResponse,
  VodAccount,
  TechStamp,
  Feed,
} from './wy-dto'

const _ = 'Show/'

export class ShowService {
  constructor(readonly r: RpcService) {}
  // 获取单个视频
  feed(d: number, m?: M): R<Feed> {
    return this.r.async(_ + 'feed', d, m)
  }
  // 获取单个视频
  feedDetail(d: FeedReq, m?: M): R<Feed> {
    return this.r.async(_ + 'feedDetail', d, m)
  }
  // 获取视频流，每次返回5条左右
  feeds(d: FeedPref, m?: M): R<Array<Feed>> {
    return this.r.async(_ + 'feeds', d, m)
  }
  // 查看频道相关视频
  findVideoByChannel(d: TopQuery, m?: M): R<FeedResponse> {
    return this.r.async(_ + 'findVideoByChannel', d, m)
  }
  // 获取指定技师最新的4条动态图片或视频
  getLatestShows(d: MiniShowQuery, m?: M): R<Array<MiniShow>> {
    return this.r.async(_ + 'getLatestShows', d, m)
  }
  // 获取视频号主页信息
  getVodAccount(d: string, m?: M): R<VodAccount> {
    return this.r.async(_ + 'getVodAccount', d, m)
  }
  // 视频号主页，流式分页返回技师所有视频，按创建时间倒序
  latestTechVideos(d: MoreVideo, m?: M): R<Array<Feed>> {
    return this.r.async(_ + 'latestTechVideos', d, m)
  }
  // 按技师推荐作品
  recShowByTech(d: RecShowReq, m?: M): R<RecShowRes> {
    return this.r.async(_ + 'recShowByTech', d, m)
  }
  // 技师贴片,根据技师id获取
  techStamp(d: string, m?: M): R<TechStamp> {
    return this.r.async(_ + 'techStamp', d, m)
  }
}
